import { EquipmentNeededListingFields } from '../redux/type';
import { EquipmentNeededKeyData, GeneralUnitList, JobDataInterface } from './types';

export function formatGeneralUnitData(data: GeneralUnitList[]) {
  const res: JobDataInterface[] = [];

  if (data?.length === 0) return [];

  data?.forEach((col: GeneralUnitList, index) => {
    const obj = {
      sn: index,
      unitId: '',
      model: '',
      vesselToolTip: [''],
      isSpotTest: '',
      id: '',
    };
    obj.id = col.UnitId;
    obj.unitId = col.UnitId;
    obj.model = col.Model;
    obj.vesselToolTip = col?.Vessels?.split(',') || [''];
    obj.isSpotTest = col?.IsSpotTest ? 'SPOT TEST' : '';
    res.push(obj);
  });

  return res;
}

export function formatEquipmentNeededData(data: EquipmentNeededListingFields[]) {
  const res: EquipmentNeededKeyData[] = [];

  if (data?.length === 0) return [];

  data?.forEach((col: EquipmentNeededListingFields, index) => {
    const obj = {
      sn: index,
      action: 'linkOff',
      status: '',
      productNumber: '',
      category: '',
      description: '',
      location: '',
      serialNumber: '',
      id: '',
      isChecked: false,
    };
    obj.id = col.ProductNumber;
    obj.status = col.Status;
    obj.productNumber = col.ProductNumber;
    obj.description = col.Description;
    obj.location = col.Location;
    obj.category = col.Category;
    obj.serialNumber = col.SerialNumber;
    res.push(obj);
  });

  return res;
}
